import { Component, OnInit } from '@angular/core';
import { Platform, RefresherCustomEvent } from '@ionic/angular';
import { Observable, Subscription } from 'rxjs';
import {
  AvtaleResponse,
  Avtaler,
  FremtidigeAvtaler
} from '../../services/avtale/avtale.types';
import { AvtaleService } from '../../services/avtale/avtale.service';
import { DataService } from '../../services/datatransfer/DataService';
import { InformationService } from 'src/app/services/notify/information.service';
import { InformationMessage } from 'src/app/services/notify/information.types';

@Component({
  selector: 'app-avtaler',
  templateUrl: './avtaler.page.html',
  styleUrls: ['./avtaler.page.scss', './avtale-kort/avtale-kort.component.scss']
})
export class AvtalePage implements OnInit {
  _avtaleResponse: Observable<AvtaleResponse>;
  showNoAnlegg = false;
  hasFetchingError: boolean;

  mineAvtaler: Avtaler[];
  mineFremtidigeAvtaler: FremtidigeAvtaler[];
  avtaleSubscription: Subscription;
  dataSubscription$: Subscription;
  subscriptionInit = false;
  kunde_id: string;
  infoMessages: InformationMessage[] = [];

  constructor(
    private _avtaleService: AvtaleService,
    public platform: Platform,
    private dataService: DataService,
    public infoService: InformationService
  ) {}

  ngOnInit() {
    this.infoService.getInfoMessages().subscribe({
      next: (res) => {
        this.infoMessages = res.filter((x) => x.aktivert) || [];
      }
    });
    this.fetchData();
  }

  fetchData() {
    this.hasFetchingError = false;
    this._avtaleResponse = this._avtaleService.getAvtaler();

    if (!this.mineAvtaler || !this.mineFremtidigeAvtaler) {
      this.avtaleSubscription = this._avtaleResponse.subscribe({
        next: (res) => {
          if (res) {
            this.mineAvtaler = res.avtaler;
            this.mineFremtidigeAvtaler = res.fremtidigeAvtaler;
            this.kunde_id = res.avtaler[0]?.kunde_id ?? '';
          } else {
            this.hasFetchingError = true;
          }
        },
        error: () => {
          this.hasFetchingError = true;
        }
      });
    }
  }

  ionViewWillEnter() {
    this.dataSubscription$ = this.dataService.getKundebytte().subscribe((x) => {
      if (x !== this.kunde_id) {
        this.mineAvtaler = undefined;
        this.mineFremtidigeAvtaler = undefined;
        this.fetchData();
      }
    });
  }

  ionViewDidLeave() {
    this.avtaleSubscription?.unsubscribe();
    this.dataSubscription$?.unsubscribe();
  }

  delay(ms: number) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }

  async doRefresh(myevent: RefresherCustomEvent) {
    // Nullstill avtaler (vis loading) og hent på nytt
    this.mineAvtaler = undefined;
    this.mineFremtidigeAvtaler = undefined;
    this.avtaleSubscription = this._avtaleResponse.subscribe((res) => {
      this.mineAvtaler = res.avtaler;
      this.mineFremtidigeAvtaler = res.fremtidigeAvtaler;
    });
    myevent.detail.complete();
  }
}
